import { render, staticRenderFns } from "./ProductItemVariantEdit.vue?vue&type=template&id=3482e805&"
import script from "./ProductItemVariantEdit.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariantEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemVariantEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports